import script from "./Disable2FAConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./Disable2FAConfirmationModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__